// extracted by mini-css-extract-plugin
export default {"container":"threecolum_container__XrWGm","feature":"threecolum_feature__1pFGn","title":"threecolum_title__EaNbH","description":"threecolum_description__4eWDN"};